module.exports = __webpack_public_path__ + "static/media/mario.d3a9ab7a.svg";